import { useEventListener } from "@react-hookz/web";
import { useState } from "react";

import { getWindow } from "shared/lib/utils";

export function useActiveElementForNewWindow() {
  const [activeElement, setActiveElement] = useState<Element | null>();
  useEventListener(getWindow(), "blur", () => {
    if (typeof globalThis === "undefined") return;
    setActiveElement(document?.activeElement);
  });
  return { activeElement };
}
